import { render, staticRenderFns } from "./TemplateGroupMember.vue?vue&type=template&id=263b8b4f&scoped=true"
import script from "./TemplateGroupMember.vue?vue&type=script&lang=js"
export * from "./TemplateGroupMember.vue?vue&type=script&lang=js"
import style0 from "./TemplateGroupMember.vue?vue&type=style&index=0&id=263b8b4f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263b8b4f",
  null
  
)

export default component.exports